/** zh-CN catalogue `builtinFx` (W3-09; English: src/render/preview/effects/builtin/builtinFx.messages.ts; terms: docs/i18n/glossary.md). */
import type { MessageCatalog } from '../../core/util/types';

const catalog: MessageCatalog = {
  ns: 'builtinFx',
  locale: 'zh-CN',
  messages: {
    approximate: '近似',
    approximateHint: 'Phira 的内置特效，由 Phiedit 根据其说明重新绘制。在 Phira 中可能略有不同。',
    chromatic: '色差',
    chromaticDesc: '从屏幕中心向外分离红色和蓝色。',
    chromaticSampleCount: '采样数',
    chromaticPower: '强度',
    circleBlur: '圆形模糊',
    circleBlurDesc: '在每个像素周围的圆形范围内扩散最亮的颜色：柔和的发光模糊。',
    circleBlurSize: '半径（px）',
    fisheye: '鱼眼',
    fisheyeDesc: '像鱼眼镜头一样放大中心（强度为正）或向内收缩（强度为负）。',
    fisheyePower: '强度',
    glitch: '故障',
    glitchDesc: '将随机的水平条带向侧面错位并分离颜色；图案每秒变化数次。',
    glitchPower: '错位',
    glitchRate: '数量',
    glitchSpeed: '每秒变化次数',
    glitchBlockCount: '条带数',
    glitchColorRate: '颜色分离',
    grayscale: '灰度',
    grayscaleDesc: '使颜色逐渐褪为灰色。',
    grayscaleFactor: '程度',
    noise: '噪点',
    noiseDesc: '将每个像素随机移动一小段距离。',
    noiseSeed: '种子',
    noisePower: '强度',
    pixel: '像素化',
    pixelDesc: '将画面变为方形色块。',
    pixelSize: '色块大小（px）',
    radialBlur: '径向模糊',
    radialBlurDesc: '向中心点模糊，类似快速缩放。',
    radialBlurCenterX: '中心 X',
    radialBlurCenterY: '中心 Y',
    radialBlurPower: '强度',
    radialBlurSampleCount: '采样数',
    shockwave: '冲击波',
    shockwaveDesc: '一个在扩散时扭曲画面的圆环。将“进度”从 0 动画到 1。',
    shockwaveProgress: '进度',
    shockwaveCenterX: '中心 X',
    shockwaveCenterY: '中心 Y',
    shockwaveWidth: '圆环宽度',
    shockwaveDistortion: '扭曲',
    shockwaveExpand: '衰减',
    vignette: '暗角',
    vignetteDesc: '使屏幕边缘逐渐变为某种颜色。',
    vignetteColor: '颜色',
    vignetteExtend: '扩散',
    vignetteRadius: '清晰范围',
    asWritten: '按原样',
    asWrittenHint: '来自谱面包的着色器。预览会像 Phira 一样按原样运行它。',
    countApproximateEffects: '{count, plural, other {# 个内置特效为近似效果}}',
    countApproximateVideos: '{count, plural, other {# 个视频为近似预览}}',
    countNotPreviewedEffects: '{count, plural, other {# 个特效未预览}}',
    countNotPreviewedVideos: '{count, plural, other {# 个视频未预览}}',
    customShader: '自定义着色器 {path}',
    missingFile: '（文件缺失）',
    notPreviewed: '未预览',
    notPreviewedHint: 'Phira 会显示它，但预览不会。它会保留在导出中。',
    verified: '已验证',
    verifiedHint: 'Phira 的内置特效，由 Phiedit 重新绘制，并已与 Phira 截图对照检查。',
    video: '视频 {path}',
    videoApproximateHint: '预览会播放该视频，但其时间和位置尚未与 Phira 对照检查。它会保留在导出中。',
    videoNotPreviewedHint: 'Phira 会播放该视频，但此版本的预览不会显示它。它会保留在导出中。',
  },
};

export default catalog;
